import { ENTITLEMENT_RANK as t } from "./entitlements.js";
import { FEATURE_REQUIREMENTS as o, Feature as a } from "./features.js";
const n = (r) => r.reduce(
  (e, i) => Math.max(e, t[i] ?? 0),
  0
), E = (r) => {
  const e = n(r);
  return e >= t.unlimited ? "unlimited" : e >= t.ai ? "aiCoach" : e >= t.pro ? "pro" : "free";
}, u = (r, e) => {
  const i = o[e];
  return n(r) >= (t[i] ?? 1 / 0);
}, c = (r) => u(r, a.UNLIMITED_HISTORY);
export {
  u as hasFeature,
  c as hasUnlimitedHistory,
  E as resolveTier
};
